

import { create } from 'zustand';
import { PoolBase } from '../types/pool';
import { Meta } from 'types/pagination';
import { SidebarSortingFilters } from 'views/admin/poolsList/components/SortingFilter/types/sortingFilters';
import { defaultFilter } from 'views/admin/poolsList/components/SortingFilter/constants/defaultFilter';

type PoolsStore = {
  allPools: PoolBase[];
  allPoolsMeta?: Meta;
	
	maxFiltersValues: Pick<SidebarSortingFilters, 'capitalization' | 'volume'>,

  allPoolsFilters: SidebarSortingFilters;

  allPoolsPage: number;
  allPoolsHasMore: boolean;

  setAllPools: (arr: PoolBase[]) => void;
  setAllPoolsMeta: (obj: Meta) => void;

  setAllPoolsFilters: (filters: SidebarSortingFilters) => void;

  setAllPoolsPage: (page: number) => void;
  setAllPoolsHasMore: (hasMore: boolean) => void;

	setMaxFiltersValues:(filters: Pick<SidebarSortingFilters, 'capitalization' | 'volume'>) => void;

	resetStore(): void;
	
  resetAllFilters(): void;
};

export const poolsStore = create<PoolsStore>(set => ({
  allPools: [],
  allPoolsMeta: undefined,

  allPoolsFilters: defaultFilter,

	maxFiltersValues:{capitalization: [0, 0], volume: [0,0]},

  allPoolsPage: 1,
  allPoolsHasMore: true,

  setAllPools: allPools => set({ allPools }),
  setAllPoolsMeta: allPoolsMeta => set({ allPoolsMeta }),

  setAllPoolsFilters: allPoolsFilters => set({ allPoolsFilters }),

  setAllPoolsPage: allPoolsPage => set({ allPoolsPage }),

  setAllPoolsHasMore: allPoolsHasMore => set({ allPoolsHasMore }),

	setMaxFiltersValues: (maxFiltersValues) => set({maxFiltersValues}),

	resetStore: () =>
		set({
			allPools: [],
			allPoolsMeta: undefined,
			allPoolsFilters: defaultFilter,
			maxFiltersValues: { capitalization: [0, 0], volume: [0, 0] },
			allPoolsPage: 1,
			allPoolsHasMore: true,
		}),

		resetAllFilters: () =>
			set({
				allPoolsFilters: { ...defaultFilter },
			}),
}));

export const usePoolsStore = poolsStore;
